/**
  * Import the external scripts from our node_modules packages
  */
import './vendor/modernizr.js';
import { WOW } from 'wowjs/dist/wow';
import 'select2/dist/js/select2.full.min.js';
import 'slick-carousel/slick/slick.min.js';
import matchHeight from 'jquery-match-height/dist/jquery.matchHeight-min.js';

function preload() {
    $('.preload').removeClass('preload');
}

/**
  * Setup WOWjs for page Animations
  */
function wowSetup() {
    var wow = new WOW({
        boxClass: 'js-animate',
        animateClass: 'animated',
        offset: 100,
        mobile: true,
        live: false
    });
    wow.init();

    if( !isDesktop() ) {
        $('.js-animate').attr('data-wow-offset', 100);
    }
}

/**
  * When you click a '#' animate the scroll the page to that point
  */
function hashScroll() {
    $('a[href*=\\#]').on('click', function(e) {
        if( $(this).attr('href') === '#' ) {
            e.preventDefault();
            return false;
        }

        if( $(this).attr('href').substring(0, 1) === '#' ) {
            const offset = $(this).data('offset');
            let destination = $(this.hash).offset().top;
            
            if (offset != undefined) {
                destination = $(this.hash).offset().top - offset;
            }

            e.preventDefault();
            $('html, body').animate(
                {
                    scrollTop: destination
                },
                500
            );
        }
    });
}

function alignElementsToWrapper() {
    const leftElements = $('.js-align-left');
    const rightElements = $('.js-align-right');
    const windowWidth = $(window).width();
    const isMobile = windowWidth < 1280;
    let wrapper;
    let wrapperOffset;

    function alignElement(element, position) {
        const mobileEnabled = element.hasClass('is-mobile');

        if( !isMobile || mobileEnabled ) {
            wrapper = $('#wrapper-js');
            wrapperOffset = wrapper.offset().left;
        } else {
            wrapperOffset = 0;
        }

        if( position === 'left' ) {
            element.css({
                marginRight: wrapperOffset,
            });
        } else {
            element.css({
                marginLeft: wrapperOffset,
            });
        }
    }

    leftElements.each(function() {
        alignElement($(this), 'left');
    });

    rightElements.each(function() {
        alignElement($(this), 'right');
    });
}

function compatibleImage() {
    if ( !Modernizr.objectfit ) {
        $('.compatible-image').each(function () {
            const this_image = $(this);
            const this_src = this_image.find('img').prop('src');

            if ( this_src ) {
                this_image
                .css('backgroundImage', 'url(' + this_src + ')')
                .addClass('background-image');
            }
        });
    }
}

function header() {
    if( isDesktop() ) {
        const header = $('.header');
        const taglines = $('.taglines');
        const arrow = $('.header-dropdown-arrow');
        const dropdownToggle = $('.header-dropdown-toggle');
        let isScrolled = false;

        // Dropdown arrow
        $(document).on('mouseenter', '.header-dropdown-toggle', function() {
            const thisDropdown = $(this);
            const thisOffset = thisDropdown.offset().left + thisDropdown.width() / 2 - 10;

            thisDropdown.addClass('is-active');
            arrow.addClass('is-active');
            arrow.css('left', thisOffset);
            header.addClass('is-scrolled');
        }).on('mouseleave', '.header-dropdown-toggle', function() {
            arrow.removeClass('is-active');
            dropdownToggle.removeClass('is-active');

            if( !isScrolled ) {
                header.removeClass('is-scrolled');
            }
        });

        // Scroll event
        $(window).on('scroll', function() {
            const thisOffset = $(this).scrollTop();
            
            if( thisOffset > 80 ) {
                header.addClass('is-scrolled');
                taglines.addClass('is-scrolled');
                isScrolled = true;
            } else {
                header.removeClass('is-scrolled');
                taglines.removeClass('is-scrolled');
                isScrolled = false;
            }
        });
    } else {
        const nav = $('.responsive-navigation');
        const navButton = $('#nav-button');
        const navDropdownTrigger = $('.responsive-dropdown-trigger');
        const navDropdown = $('.responsive-navigation-dropdown');
        const navDropdownClose = $('.responsive-navigation-dropdown__close');
        const navItemStandard = $('.responsive-navigation-item:not(".responsive-navigation-item-has-children")');

        // Toggle Navigation
        navButton.on('click', function() {
            if( navButton.hasClass('is-open') ) {
                navButton.removeClass('is-open');
                nav.removeClass('is-open');
                navDropdown.removeClass('is-open');
            } else {
                navButton.addClass('is-open');
                nav.addClass('is-open');
            }
        });

        // Navigation dropdown
        navDropdownTrigger.on('click', function() {
            const thisItem = $(this);
            const thisParent = thisItem.parent();
            const thisDropdown = thisParent.find('.responsive-navigation-dropdown');

            navDropdown.removeClass('is-open');
            thisDropdown.addClass('is-open');
        });

        // Close navigation dropdown
        navDropdownClose.on('click', function() {
            navDropdown.removeClass('is-open');
        });
    }
}

function slider() {
    const slider = $('#slider');

    if( !slider.length ) {
        return false;
    }

    slider.slick({
        prevArrow: '<button type="button" class="gallery-prev gallery-control"></button>',
        nextArrow: '<button type="button" class="gallery-next gallery-control"></button>',
        slidesToShow: 1,
        draggable: true,
        dots: true,
        variableWidth: true,
        infinite: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    variableWidth: false,
                    infinite: false
                }
            }
        ]
    }); 
}

function footer() {
    if( $('.sign-up').length ) {
        $('.footer').addClass('is-signup');
    }
}

function cookieBar() {
    var isClosed = false;

    // Check if cookie is set, no need to use value as if the cookie is set then it will equal true.
    if (document.cookie.split('; ').find(row => row.startsWith('noticeClosed='))) {
        isClosed = true;
    }

    if (!$('.cookie-bar').length || isClosed) {
        $('.cookie-bar').remove();
        return false;
    }

    var bar = $('.cookie-bar');

    // Show bar
    bar.addClass('is-open');

    // Close bar
    bar.find('button').on('click', function() {
        // Add cookie for 2 weeks
        var today = new Date();
        var expiry = new Date();
        expiry.setTime(today.getTime() + 3600000*24*14);
        document.cookie = 'noticeClosed=true; expires=' + expiry.toGMTString() + '; path=/';

        bar.removeClass('is-open');

        this.setTimeout(function() {
            bar.remove();
        }, 500);
    });
}

/**
  * Initialize Image Text Carousel
  */
function imageTextCarousel() {
    const carousel = $('.js-image-carousel');
    
    if( !carousel.length ) {
        return false;
    }

    carousel.slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: true,
        infinite: true,
        adaptiveHeight: true
    });
}

/**
  * Initialize Review Slider
  */
function reviewSlider() {
    const slider = $('.js-review-slider');
    
    if( !slider.length ) {
        return false;
    }

    // Shuffle slides randomly
    const slides = slider.children();
    slides.sort(function() {
        return 0.5 - Math.random();
    });
    slider.append(slides);

    const slideCount = slider.children().length;

    slider.slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: slideCount > 1,
        dots: slideCount > 1,
        infinite: slideCount > 1,
        adaptiveHeight: true,
        mobileFirst: true
    });
}

/**
  * Initialize Card Slider
  */
function cardSlider() {
    const slider = $('.js-card-slider');

    if( !slider.length ) {
        return false;
    }

    slider.slick({
        arrows: true,
        prevArrow: '<button type="button" class="card-slider-prev gallery-control"></button>',
        nextArrow: '<button type="button" class="card-slider-next gallery-control"></button>',
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: true,
        infinite: true,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

/**
  * Initialize Article Content Navigation
  */
function articleContentNavigation() {
    const mainContent = $('.article-content__main');
    const sidebarNavigation = $('.article-content__sidebar-navigation');

    if (mainContent.length && sidebarNavigation.length) {
        let counter = 1;
        const headings = mainContent.find('h1, h2, h3, h4');
        const navigationLinks = [];

        headings.each(function() {
            const heading = $(this);
            const headingId = `heading_${counter}`;
            heading.attr('id', headingId);

            const listItem = $('<li></li>');
            const anchorLink = $(`<a href="#${headingId}">${heading.text()}</a>`);
            anchorLink.addClass('article-content__sidebar-link');

            anchorLink.on('click', function(event) {
                event.preventDefault();
                const targetElement = $(`#${headingId}`);
                if (targetElement.length) {
                    $('html, body').animate({
                        scrollTop: targetElement.offset().top - 120
                    }, 500);
                }
            });

            listItem.append(anchorLink);
            sidebarNavigation.append(listItem);

            navigationLinks.push({
                link: anchorLink,
                heading: heading
            });

            counter++;
        });

        // Update active link on scroll
        $(window).on('scroll', function() {
            const scrollTop = $(window).scrollTop() + 200;
            const windowHeight = $(window).height();
            const viewportMiddle = scrollTop + (windowHeight / 2);

            // Remove active class from all first
            navigationLinks.forEach(function(item) {
                item.link.closest('li')[0].classList.remove('active');
            });

            // Find the heading closest to viewport middle
            let closestHeading = null;
            let closestDistance = Infinity;

            navigationLinks.forEach(function(item) {
                const headingTop = item.heading.offset().top;
                const distance = Math.abs(viewportMiddle - headingTop);

                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestHeading = item;
                }
            });

            // Add active class to the closest heading
            if (closestHeading && closestDistance < windowHeight / 2) {
                closestHeading.link.closest('li')[0].classList.add('active');
            }
        });

        // Trigger scroll check on load
        $(window).trigger('scroll');
    }
}

/**
  * Initialize Blog Archive Load More
  */
function blogArchiveLoadMore() {
    const loadMoreButton = $('.blog-archive__load-more');
    const items = $('.blog-archive__item');

    if (loadMoreButton.length && items.length) {
        let visibleCount = 10;

        loadMoreButton.on('click', function() {
            const hiddenItems = items.not('.blog-archive__item--visible');
            const itemsToShow = hiddenItems.slice(0, 12);

            itemsToShow.addClass('blog-archive__item--visible');
            visibleCount += itemsToShow.length;

            // Hide button if all items are visible
            if (visibleCount >= items.length) {
                loadMoreButton.hide();
            }
        });
    }
}

/**
  * Initialize Search Tags Filtering
  */
function searchTagsFilter() {
    const buttons = $('.search-tags button');
    const specialistsSection = $('.search-results__specialists');
    const articlesSection = $('.search-results__articles');
    const productsSection = $('.search-results__products');
    const pagesSection = $('.search-results__pages');
    const faqsSection = $('.search-results__faqs');
    const lineBreaks = $('.search-results__line-break');
    const resultsCount = $('.results-count');

    // Store original counts
    const specialistsCount = specialistsSection.length ? parseInt($('.search-results__specialists .post-type-heading').text()) : 0;
    const articlesCount = articlesSection.length ? parseInt($('.search-results__articles .post-type-heading').text()) : 0;
    const productsCount = productsSection.length ? parseInt($('.search-results__products .post-type-heading').text()) : 0;
    const pagesCount = pagesSection.length ? parseInt($('.search-results__pages .post-type-heading').text()) : 0;
    const faqsCount = faqsSection.length ? parseInt($('.search-results__faqs .post-type-heading').text()) : 0;
    const totalCount = specialistsCount + articlesCount + productsCount + pagesCount + faqsCount;

    if (buttons.length) {
        buttons.on('click', function() {
            const type = $(this).data('type');

            // Update active class
            buttons.removeClass('is-active');
            $(this).addClass('is-active');

            // Hide all sections and line breaks first
            specialistsSection.hide();
            articlesSection.hide();
            productsSection.hide();
            pagesSection.hide();
            faqsSection.hide();
            lineBreaks.hide();

            // Show relevant sections based on type
            let visibleCount = 0;

            if (type === 'all' || type === 'specialists') {
                specialistsSection.show();
                visibleCount += specialistsCount;
            }

            if (type === 'all' || type === 'articles') {
                articlesSection.show();
                visibleCount += articlesCount;
            }

            if (type === 'all' || type === 'products') {
                productsSection.show();
                visibleCount += productsCount;
            }

            if (type === 'all' || type === 'pages') {
                pagesSection.show();
                visibleCount += pagesCount;
            }

            if (type === 'all' || type === 'faqs') {
                faqsSection.show();
                visibleCount += faqsCount;
            }

            // Show line breaks between visible sections
            if (specialistsSection.is(':visible')) {
                specialistsSection.next('.search-results__line-break').show();
            }
            if (articlesSection.is(':visible')) {
                articlesSection.next('.search-results__line-break').show();
            }
            if (productsSection.is(':visible')) {
                productsSection.next('.search-results__line-break').show();
            }
            if (pagesSection.is(':visible')) {
                pagesSection.next('.search-results__line-break').show();
            }
            if (faqsSection.is(':visible')) {
                faqsSection.next('.search-results__line-break').show();
            }

            // Update results count
            resultsCount.text(visibleCount);
        });
    }
}

/**
  * Call the functions when the document is ready
  */
$(document).ready(function() {
    hashScroll();
    alignElementsToWrapper();
    matchHeights();
    compatibleImage();
    header();
    slider();
    imageTextCarousel();
    reviewSlider();
    cardSlider();
    footer();
    articleContentNavigation();
    blogArchiveLoadMore();
    searchTagsFilter();

    // Init MatchHeight
    $('.mh').matchHeight();
});

$(window).on('load', function() {
    preload();
    setTimeout(cookieBar, 2000);
    setTimeout(wowSetup, 500);
});

/**
  * Call the functions when the window is resized
  */
$(window).on('resize', function() {
    alignElementsToWrapper();
});

import './product.js';
import './form.js';
import './advanced-search.js';
import './search.js';
import './pagination.js';
import './account.js';